import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDBm-4-uUONlt1HdAEWH1hipVsqRXpLDOI",
    authDomain: "sim-racing-league-manager.firebaseapp.com",
    databaseURL: "https://sim-racing-league-manager.firebaseio.com",
    projectId: "sim-racing-league-manager",
    storageBucket: "sim-racing-league-manager.appspot.com",
    messagingSenderId: "362606560705",
    appId: "1:362606560705:web:e5717544425e15f2b3db40",
    measurementId: "G-Q6E8H6RZYW",
};

firebase.initializeApp(firebaseConfig);

const functions = firebase.functions();
const auth = firebase.auth();
const storage = firebase.storage();
const firestore = firebase.firestore();
const TaskEvent = firebase.storage.TaskEvent;
const TaskState = firebase.storage.TaskState;

if (process.env.NODE_ENV === "development") {
    // auth.useEmulator("http://localhost:9099");
    // functions.useEmulator("localhost", 5001);
    // storage.useEmulator("localhost", 9199);
    // firestore.useEmulator("localhost", 8080);
}

export { TaskEvent, TaskState, functions };
export default firebase;
